import { render, staticRenderFns } from "./nameAuthenticationbind.vue?vue&type=template&id=07da18ed&scoped=true&"
import script from "./nameAuthenticationbind.vue?vue&type=script&lang=js&"
export * from "./nameAuthenticationbind.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07da18ed",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\sdk_manage_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07da18ed')) {
      api.createRecord('07da18ed', component.options)
    } else {
      api.reload('07da18ed', component.options)
    }
    module.hot.accept("./nameAuthenticationbind.vue?vue&type=template&id=07da18ed&scoped=true&", function () {
      api.rerender('07da18ed', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/authentication/nameAuthenticationbind.vue"
export default component.exports